import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs-compat/Observable';
import { ServiceBase } from 'app/shared/infrastructure/serviceBase.component'; // leaf import - do not revert to the barrel (app/shared/infrastructure), breaks ng test (circular dependency)
import { environment } from 'environments/environment';

@Injectable()
export class AggregatorWhatsappSetupService extends ServiceBase {

    constructor(private _http: HttpClient) {
        super();
    }

    getEnableWhatsapp = (): Observable<any> => {
        return this._http.get<any>(`${environment.httpAggregatorApi}WhatsappNotification/EnableWhatsapp`);
    }

    getTemplates = (): Observable<any> => {
        return this._http.get<any>(`${environment.httpAggregatorApi}WhatsappNotification/Templates`);
    }

    getAllSetups = (): Observable<any> => {
        return this._http.get<any>(`${environment.httpAggregatorApi}WhatsappNotificationSetup`);
    }

    createSetup = (data: any): Observable<any> => {
        return this._http.post<any>(`${environment.httpAggregatorApi}WhatsappNotificationSetup`, data);
    }

    updateSetup = (data: any): Observable<any> => {
        return this._http.put<any>(`${environment.httpAggregatorApi}WhatsappNotificationSetup`, data);
    }

    deleteSetup = (id: string): Observable<any> => {
        return this._http.delete<any>(`${environment.httpAggregatorApi}WhatsappNotificationSetup?id=${id}`);
    }

    labResultNotification = (report: any): Observable<any> => {
        return this._http.post<any>(`${environment.httpAggregatorApi}WhatsappNotification/LabResultNotification`, report);
    }

    labResultNotificationByPatientCode = (data: any): Observable<any> => {
        return this._http.post<any>(`${environment.httpAggregatorApi}WhatsappNotification/LabResultNotificationByPatientCode`, data);
    }

    sendRadiologyResult = (dto: any): Observable<any> => {
        return this._http.post<any>(
            `${environment.httpAggregatorApi}WhatsappNotification/SendRadiologyResult`,
            dto
        );
    }

    sendBillingInvoice = (dto: any): Observable<any> => {
    return this._http.post<any>(
        `${environment.httpAggregatorApi}WhatsappNotification/SendBillingInvoice`,
        dto
    );
}
}
